import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import API from '../../services/API';
import { Fab, IconButton } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import PopupDB from './PopupDB';
import {useSnackbar} from 'notistack';




export default function FournisseurConditions(){
    const [fournisseurConditions, setFournisseurConditions] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false)
    const [dataChange, setDataChange] = useState(true)
    const [actionPopup, setActionPopup] = useState("Créer")
    const [modifyingData, setModifyingData] = useState({})

    const { enqueueSnackbar } = useSnackbar();

    const columns = [
        {field: 'actions', headerName: 'Actions', sortable: false,
            renderCell: (params) => {
              const onClickModify = (e) => {
                e.stopPropagation(); // don't select this row after clicking
                handleModify(params.row)
              };
              const onClickDelete = (e) => {
                e.stopPropagation(); // don't select this row after clicking
                let conf = window.confirm("Etes-vous sûr de vouloir supprimer cette condition fournisseur ? Pas de retour en arrière ...")
                if(conf){
                    handleDelete(params.row)
                }
              };
        
              return(
                  <>
                      <IconButton color="primary" component="span" onClick={onClickModify}><Edit /></IconButton>
                      <IconButton color="primary" component="span" onClick={onClickDelete}><Delete /></IconButton>
                  </>
              )
            },
        },
        { field: 'id'},
        { field: 'Fournisseur', valueGetter: (params) => {
            return `(#${params.row.Fournisseur_id}) ${params.row.Fournisseur_nom}`;
        }},
        { field: 'Produit', valueGetter: (params) => {
            return `(#${params.row.Produit_id}) ${params.row.Produit_nom}`;
        }},
        { field: 'prix', headerName: 'Prix'},
        { field: 'jour_commande', headerName: 'Jour de commande'},
        { field: 'heure_commande', headerName: 'Heure de commande'},
        { field: 'jour_reception', headerName: 'Jour de réception'},
        { field: 'type', headerName: 'Type'},
        { field: 'ordre', headerName: 'Ordre'},
        { field: 'commentaire', headerName: 'Commentaire'}
    ];

    useEffect(()=>{
        if(!dataChange) return
        API('GET','Fournisseur_Condition')
        .then(res=>setFournisseurConditions(res.json))
        setDataChange(false)
    },[dataChange])

    const handleAdd = ()=>{
        setActionPopup("Créer")
        setModifyingData({})
        setPopupOpen(true)
    }

    const handleModify = (data)=>{
        let tmp = {...data}
        delete tmp.Produit_nom
        delete tmp.Fournisseur_nom
        setActionPopup("Modifier")
        setModifyingData(tmp)
        setPopupOpen(true)
    }
    const handleDelete = (data)=>{
        API("DELETE","Fournisseur_Condition",{id:data.id})
        .then(res=>{
            if(!res.ok){//ERREUR
                enqueueSnackbar("Erreur lors de la suppression : "+res.json.message,{variant: "error"})
            }else{
                enqueueSnackbar("Suppression réussie",{variant: "success"})
            }
            setDataChange(true)
        })
    }

    return (
        <>
            <DataGrid
                rows={fournisseurConditions}
                columns={columns}
                disableSelectionOnClick 
                autoHeight
            />
            <Fab color="primary" aria-label="Add" sx={{position: "fixed", bottom: "10px", right: "10px"}} onClick={handleAdd}>
                <Add />
            </Fab>
            <PopupDB action={actionPopup} data={modifyingData} extraData={[]}  table="Fournisseur_Condition" open={popupOpen} setOpen={setPopupOpen} setDataChange={setDataChange}/>
        </>
    )
}